import React, { useState } from 'react';
import Calendar from 'react-day-picker';
import { Paragraph, H3 } from '../Typography';
import inputStyles from '../Input.module.scss';
import styles from './DatePicker.module.scss';
import './DatePicker.scss';
import { formatDate, shortDays } from '../../utils/date';
import { WhiteModal } from '../Modal';
import { ClickableBox, SpacingBox } from '../Boxes';
import {
  PrimaryButton,
  FluidPrimaryButton,
  InvertedFluidPrimaryButton,
} from '../Button';
import 'react-day-picker/lib/style.css';
import { getTranslateByScope } from '../../i18n';

import { Mobile, NotMobile } from '../Responsive';

const translate = getTranslateByScope('app.components.datePicker');

export const DatePickerToggler = ({
  value,
  onClick,
  placeholder,
  className,
}) => (
  <ClickableBox onClick={onClick}>
    <div className={inputStyles.input}>
      <Paragraph className={className}>
        {value ? formatDate(value) : placeholder}
      </Paragraph>
    </div>
  </ClickableBox>
);

export const DatePicker = ({
  value, onConfirm, placeholder, className,
}) => {
  const [isOpen, open] = useState(false);
  const [newValue, setNewValue] = useState(value);

  const handleDayClick = (s) => {
    setNewValue(s);
  };

  const handleConfirm = () => {
    onConfirm(newValue);
    open(false);
  };

  const handleOpen = () => {
    setNewValue(value);
    open(true);
  };

  const handleClear = () => {
    onConfirm(null);
    open(false);
  };

  const handleCancel = () => {
    setNewValue(value);
  };

  return (
    <>
      <WhiteModal onCancel={handleCancel} isOpen={isOpen}>
        <Calendar
          showOutsideDays
          weekdaysShort={shortDays()}
          firstDayOfWeek={1}
          month={null}
          enableOutsideDaysClick={false}
          onDayClick={handleDayClick}
          selectedDays={newValue}
          className="sch-date-picker"
          todayButton={
            <H3 className={styles.todayButton}>{translate('today')}</H3>
          }
        />
        <div className={styles.buttons}>
        <NotMobile>
          <div className={styles.button}>
            <PrimaryButton
              onClick={handleClear}
              text={translate('clear')}
            />
          </div>
          <div className={styles.button}>
            <PrimaryButton
              onClick={handleConfirm}
              text={translate('confirm')}
            />
          </div>
        </NotMobile>

        <Mobile>
          <InvertedFluidPrimaryButton
            onClick={handleCancel}
            text={translate('cancel')}
          />
          <SpacingBox marginTop="sm">
            <FluidPrimaryButton
              onClick={handleClear}
              text={translate('clear')}
            />
          </SpacingBox>
          <SpacingBox marginTop="sm">
            <FluidPrimaryButton
              onClick={handleConfirm}
              text={translate('confirm')}
            />
          </SpacingBox>
        </Mobile>
        </div>
      </WhiteModal>
      <DatePickerToggler
        className={className}
        placeholder={placeholder}
        onClick={handleOpen}
        value={value}
      />
    </>
  );
};

DatePicker.defaultProps = {
  onConfirm: () => {},
};

export const DatePickerWithLabel = (props) => (
  <>
    <Paragraph className={styles.inputLabel}>{props.label}</Paragraph>
    <DatePicker className={styles.withLabel} {...props} />
  </>
);
